module.exports = __webpack_public_path__ + "img/criticaledition_matrix_active.3d77a82d.svg";